import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import Spinner from '../../../../components/Spinner'
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import axioPath from '../../../../../api/axioPath';

import { stateConvert } from 'web/components/utils/stateAbbreviation';
import AlertModal from 'web/components/AlertModal';
import Button from 'web/components/Button';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'

const SubLocationsListPage = ({ togglePage, subLocationsList, fetchMyAPISubLocation }) => {
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [dataList, setDataList] = useState([])
  const [finalData, setFinalData] = useState([])
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [searchDataList, setSearchDataList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const toggleModal = () => { setModal(!modal); }

  let headerArr = [
    { title: 'Location Name', },
    { title: 'Address', },
    { title: 'FC Member ', },
    { title: 'Account Type', },
    { title: 'Broker', },
    { title: 'Location Status', }
  ];

  const handleChange = (event, value) => {
    setPage(value);
    let dataListtemp = JSON.parse(JSON.stringify(searchDataList))
    let pageData = JSON.parse(JSON.stringify(dataListtemp))
    setFinalData(pageData.splice(value * 10 - 10, 10))
  };

  useEffect(() => {
    initialDataSet();
  }, [subLocationsList]);

  const initialDataSet = () => {
    if (subLocationsList && subLocationsList.subLocationList.length > 0) {
      setDataList(subLocationsList.subLocationList)
      setSearchDataList(subLocationsList.subLocationList)
      let pageData = JSON.parse(JSON.stringify(subLocationsList.subLocationList))
      setFinalData(pageData.splice(page * 10 - 10, 10))
      if (subLocationsList.subLocationList.length % 10 === 0) {
        setPageCount(subLocationsList.subLocationList.length / 10)
      } else {
        setPageCount(Math.trunc(subLocationsList.subLocationList.length / 10) + 1)
      }
    }
  };

  const handleStatusChange = (e, items) => {
    e.preventDefault()
    const token = localStorage.getItem("token");
    let url = ''
    if (items.active) url = '/user/location/deactivate'
    else url = '/user/location/activate'
    axioPath.post(url, {}, {
      headers: {
        Authorization: `${token}`,
        authId: items.authId,
        locationId: items.id
      },
    }).then((response) => {
      setModal(!modal)
      setModalContent(response.data.message)
      // fetchMyAPI('updateSubList')
      fetchMyAPISubLocation('updateSubList', subLocationsList, items.id)
    }).catch((ex) => {
    });
  }

  return (
    <>
      <TableWrapper>
        {loaderVisible && <Spinner />}
        <Heading>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3>Sublocations list</h3>
          </div>
        </Heading>
        <Table responsive>
          <thead>
            <tr>
              {headerArr.map((items, index) => (
                <th key={index}>{items.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {
              finalData.map((items, index) => (
                <tr key={index}>
                  <td>{items.locationName}</td>
                  <td>{items.address && `${items.address.city}, ${stateConvert(items.address.state)}, ${items.address.zip}`}</td>
                  <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                  <td>{(items.isBuying && items.isSelling) ? 'Both' : items.isBuying ? 'Buyer' : items.isSelling ? 'Seller' : 'NA'}</td>
                  <td>{items.isReselling ? 'Yes' : 'No'}</td>
                  <td>{items.active ? 'Active' : 'Inactive'}
                    {/* <FormControlLabel
                        style={{ margin: 0 }}
                        labelPlacement="start"
                        label={items.active ? 'Active' : 'Inactive'}
                        control={
                            <Switch
                                checked={items.active}
                                onClick={e => handleStatusChange(e, items)}
                                name="checkedB"
                                color="primary"
                                disabled={!subLocationsList.active}
                            />
                        }
                    /> */}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        {finalData.length === 0 &&
          <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
        }
        {finalData.length !== 0 && dataList.length !== 0 && <Pagination count={pageCount}
          page={page}
          onChange={handleChange} />}
      </TableWrapper>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
      />
      <Button
        type='app-green-button submitBtn'
        handleClick={() => togglePage('MainLocations')}
      >
        Back
      </Button>
    </>

  )
};

export default SubLocationsListPage;